import React from "react";
import BackgroudImage from "../assets/images/bg/3.jpg";
import { useTranslation } from "react-i18next";
import { ArrowRightOutlined } from "@ant-design/icons";
import { Link } from "react-router-dom";

export default function SecurityBanner() {
  const { t } = useTranslation();
  return (
    <>
      <div>
        <section
          style={{ backgroundImage: `url(${BackgroudImage})` }}
          className="py-16 lg:py-16 w-full table relative bg-center bg-cover pl-5"
          id="home"
        >
          <div className="absolute inset-0 bg-black opacity-80"></div>
          <div className="container relative">
            <div className="grid grid-cols-1 mt-12 flex justify-between">
              <div className="">
                <h4 className="text-white lg:text-4xl text-3xl font-medium mb-7 flex">
                  <i>
                    {t("providing_brilliant")}{" "}
                    <ArrowRightOutlined
                      style={{ color: "#8080ff", fontStyle: "bold" }}
                    />{" "}
                    <b className="text-[#8080ff] pr-2">{t("security")}</b>{" "}
                  </i>
                  <div className="ml-3 border"></div>
                  <div className="flex flex-col ml-3 text-orange-400 text-2xl">
                  <Link to="/solutions/CrimeInvestigation" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("crime_investigation")} </Link>
                    <Link to="/solutions/FraudDetection" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("fraud_detection")} </Link>
                    <Link to="/solutions/IntrusionDetection" className="p-2 hover:bg-slate-600 rounded-lg duration-300"> {t("intrusion_detection")}  </Link>
                  </div>
                </h4>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}
